import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Nebular imports removed - no longer using Nebular theme framework

import { FooterComponent, HeaderComponent } from './components';
import { OneColumnLayoutComponent } from './layouts';
// import { DEFAULT_THEME } from './styles/theme.default';
// import { MATERIAL_LIGHT_THEME } from './styles/material/theme.material-light';

const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  OneColumnLayoutComponent,
];

@NgModule({
  imports: [CommonModule, RouterModule],
  exports: [],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        // Nebular theme providers removed - using PrimeNG themes instead
      ],
    };
  }
}
